/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Title_AccentInputs */

const tr_landing_pricing_title_accent = /** @type {(inputs: Landing_Pricing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gizli ücret yok`)
};

const en_landing_pricing_title_accent = /** @type {(inputs: Landing_Pricing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no hidden fees`)
};

const de_landing_pricing_title_accent = /** @type {(inputs: Landing_Pricing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keine versteckten Kosten`)
};

const ru_landing_pricing_title_accent = /** @type {(inputs: Landing_Pricing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`без скрытых платежей`)
};

/**
* | output |
* | --- |
* | "no hidden fees" |
*
* @param {Landing_Pricing_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_title_accent = /** @type {((inputs?: Landing_Pricing_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_title_accent(inputs)
	if (locale === "de") return de_landing_pricing_title_accent(inputs)
	if (locale === "ru") return ru_landing_pricing_title_accent(inputs)
	return tr_landing_pricing_title_accent(inputs)
});